module.exports = __webpack_public_path__ + "static/media/logo_azul.69caf7e4.svg";